/**
 * Redirect para Settings > Integrações > Chaves de API.
 *
 * BYOK virou sub-integração dentro de Configurações (saiu do menu lateral
 * "Inteligência"). Esta rota mantém compat com bookmarks antigos.
 */

import { Redirect } from "wouter";

export default function LLMCredentials() {
  return <Redirect to="/settings?tab=integrations&integration=llm" />;
}
